import React, { Component } from "react";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";
import { I18n } from "react-redux-i18n";

import "../../../styles/components/utils/components/DoubleRadioCard.scss";
import friends from "../../../styles/images/friends.svg";
import avatar from "../../../styles/images/avatar.svg";

class DoubleRadioCard extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <>
        <div id="doubleRadioCard" className={"card " + this.props.type}>
          <div className="main-container">
            <img
              className="avatar"
              src={
                this.props.avatar
                  ? this.props.avatar
                  : this.props.type === "person"
                    ? avatar
                    : friends
              }
              alt=""
            />
            <div className="name-container">
              <p className="name">{this.props.name}</p>
              {this.props.type === "person" && (
                <p className="info">{this.props.info}</p>
              )}
            </div>
            <div className="grid-container">
              <div className="check-container">
                <input
                  type="checkbox"
                  checked={this.props.checkedIndex === 0}
                  onChange={() =>
                    this.props.onChange(this.props.type, this.props.id, 0)
                  }
                  disabled={
                    this.props.selectedEV?.clientName === "KINTO" ? true :
                      this.props.checkedGroups?.length >= 1
                        ? true
                        : this.props.checkedDrivers?.length === 1
                          ? false
                          : true
                  }
                />
                {this.props.selectedEV?.clientName === "KINTO" ? <div className="check-disabled" /> :
                  this.props.checkedGroups?.length >= 1 ? (
                    <div className="check-disabled" />
                  ) : this.props.checkedDrivers?.length === 1 ? (
                    <div className="check" />
                  ) : (
                    <div className="check-disabled" />
                  )}
              </div>
              <div className="check-container">
                <input
                  type="checkbox"
                  checked={this.props.checkedIndex === 1}
                  onChange={() =>
                    this.props.onChange(this.props.type, this.props.id, 1)
                  }
                />
                <div className="check" />
              </div>
            </div>
          </div>
        </div>
        {this.props.tabIndex === 2 &&
          this.props.checkedDrivers?.length === 1 &&
          this.props.checkedGroups?.length < 1 &&
          this.props.checkedDrivers[0].paymenteBy === "driver" &&
          this.props.checkedIndex === 1 && (
            <div className="invoice-section">
              <p>{I18n.t("assignDriver_invoiceType")}</p>
              <div className="select-container invoice-select">
                <Form.Control
                  as="select"
                  value={this.props.invoiceType}
                  onChange={(e) => this.props.onChangeInvoiceType(e)}
                  required
                >
                  <option value="INVOICE_INCLUDED">
                    {I18n.t("assignDriver_globalnvoice")}
                  </option>
                  <option value="INVOICE_INDIVIDUAL">
                    {I18n.t("assignDriver_individualityInvoice")}
                  </option>
                </Form.Control>
              </div>
            </div>
          )}
        {this.props.tabIndex === 2 &&
          this.props.checkedDrivers?.length === 1 &&
          this.props.checkedGroups?.length < 1 &&
          this.props.checkedIndex === 1 &&
          this.props.invoiceType === "INVOICE_INDIVIDUAL" && (
            <div className="invoice-section">
              <p>{I18n.t("assignDriver_communicationType")}</p>
              <div className="select-container invoice-select">
                <Form.Control
                  as="select"
                  value={this.props.invoiceCommunication}
                  onChange={(e) => this.props.onChangeInvoiceCommunication(e)}
                  required
                >
                  <option value="ONLY_COMPANY">
                    {I18n.t("assignDriver_onlyCompany")}
                  </option>
                  <option value="ONLY_DRIVER">
                    {I18n.t("assignDriver_onlyDriver")}
                  </option>
                  <option value="DRIVER_COMPANY">
                    {I18n.t("assignDriver_toCompanyDriver")}
                  </option>
                </Form.Control>
              </div>
            </div>
          )}
      </>
    );
  }
}

DoubleRadioCard.propTypes = {
  type: PropTypes.string.isRequired,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  avatar: PropTypes.string,
  info: PropTypes.string,
  checkedIndex: PropTypes.number.isRequired,
  onSubmit: PropTypes.func,
};

export default DoubleRadioCard;
